import { UserType } from "@istari/istari-client";

import type { InternalUserType } from "~/api/user/user";
import { resolveUserDisplayName } from "~/user/utils/format-user-name";

export function toNotificationActorName(user: InternalUserType | null | undefined): string | null {
  if (!user) return null;
  return resolveUserDisplayName(user);
}

export function getAgentFallbackId(user: InternalUserType | null | undefined): string | null {
  if (!user || user.userType !== UserType.Agent) return null;
  if (toNotificationActorName(user)) return null;
  return user.providerUserId || null;
}
